import PropTypes from "prop-types";
import { useEffect, useState } from "react";
// import { useAuth } from "../../context/useAuth";
import { useHistory } from "react-router-dom";
import { storage } from "../../Utils/storageService";

function RequireAuth({ children }) {
  // const { user } = useAuth();
  const [token, setToken] = useState(storage.getToken());
  const [user, setUser] = useState(storage.getLoginId());

  const history = useHistory();
  useEffect(() => {
    setToken(storage.getToken());
    setUser(storage.getLoginId());
  }, [user]);

  useEffect(() => {
    if (!user || !token) {
      history.replace("/");
    }
  }, [user, token, history]);

  if (!user || !token) {
    return null;
  }

  return children;
}

export default RequireAuth;

RequireAuth.propTypes = {
  children: PropTypes.any.isRequired,
};
